export const LANGUAGE_PROP = "lang";

export const END_USER_PROPS = "endUser_";
